import { io, Socket } from "socket.io-client"

export const criarSocket = (idOrganizacao: string, idUsuario?: string): Socket => {
    const socket = io(process.env.REACT_APP_API_ZAI, {
        transports: ["websocket"],
        autoConnect: false,
        query: { idOrganizacao, idUsuario }
    })

    socket.connect()
    socket.on('connect', () => {
        socket.emit("salaOrganizacao", idOrganizacao)
    })

    return socket
}